/*
 * @author: wayou
 * @date: 2018-09-11 12:03:42
 * @description: 媒体播放时间的展示 HH:MM:SS[/ HH:MM:SS]
 */

import React, { Component } from 'react';
import './mediaTimeDisplay.scss';

interface IMediaTimeDisplayProps {
    time: number;
    duration: number;
    /**
     * 是否只展示播放进行中的时间而不是 mm:ss/mm:ss
     */
    displaySingleTime?: boolean;
}

interface IMediaTimeDisplayState {
    isOverview: boolean;
}

export default class MediaTimeDisplay extends Component<IMediaTimeDisplayProps, IMediaTimeDisplayState> {
    public static defaultProps: Partial<IMediaTimeDisplayProps> = {
        time: 0,
        duration: 0,
        displaySingleTime: false,
    };

    public render() {
        const { time, duration, displaySingleTime } = this.props;
        const time2Display = this.getDisplayTime(time, duration, displaySingleTime);
        return <div className="media-time-display">{time2Display}</div>;
    }

    private getDisplayTime(time: number, total: number, displaySingleTime: boolean = false): string {
        let formatedTime = this.formatTime2HHMMSS(time > 0 ? time : 0);
        let formatedTotal = this.formatTime2HHMMSS(total);

        // 如果小时为 0 则不展示
        if (formatedTotal.split(':')[0] === '00') {
            formatedTime = this.removeHour(formatedTime);
            formatedTotal = this.removeHour(formatedTotal);
        }
        if (displaySingleTime) {
            if (time === 0) {
                return formatedTotal;
            } else {
                return formatedTime;
            }
        }
        return `${formatedTime} / ${formatedTotal}`;
    }

    private formatTime2HHMMSS(seconds: number) {
        const date = new Date(null as any /* NOTE: null 来生成一个空时间  */);
        date.setMilliseconds(seconds);
        return date.toISOString().substr(11, 8);
    }

    private removeHour(formatedTime: string): string {
        return formatedTime
            .split(':')
            .slice(1)
            .join(':');
    }
}
